module.exports = __webpack_public_path__ + "img/India.a814c844.gif";